// src/components/Layout/RightSidebar/RightSidebar.tsx
import React, { useState } from 'react';
import { Settings, Layers } from 'lucide-react';
import { LayersPanel } from '@components/Sidebar/LayersPanel';
import { PropertiesPanel } from '@/components/Properties/PropertiesPanel';

type TabType = 'properties' | 'layers';

export const RightSidebar: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('properties');

  return (
    <div className="flex h-full w-full flex-col border-l border-gray-200 bg-gray-50 shadow-2xl dark:border-slate-700 dark:bg-slate-900">
      {/* Tabs */}
      <div className="flex border-b border-gray-200 dark:border-slate-700">
        <button
          onClick={() => setActiveTab('properties')}
          className={`flex flex-1 items-center justify-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'properties'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
          }`}
        >
          <Settings className="h-4 w-4" />
          Properties
        </button>

        <button
          onClick={() => setActiveTab('layers')}
          className={`flex flex-1 items-center justify-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'layers'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
          }`}
        >
          <Layers className="h-4 w-4" />
          Layers
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'properties' ? <PropertiesPanel /> : <LayersPanel />}
      </div>
    </div>
  );
};
